<template>
    <div
        class="sbs-base-avatar"
        :class="themeClasses"
        :style="avatarStyles">
        <!-- @slot Слот по-умолчанию -->
        <slot>
            <SbsImage
                v-if="imageSrc"
                class="sbs-base-avatar__image"
                v-bind="imageData">
                <template #stub="{ isStubVisible }">
                    <div
                        v-if="isStubVisible"
                        class="sbs-base-avatar__image-stub">
                        <span class="sbs-base-avatar__text text-clamp">
                            {{ text }}
                        </span>
                    </div>
                </template>
            </SbsImage>

            <span
                v-else
                class="sbs-base-avatar__text text-clamp">
                {{ text }}
            </span>
        </slot>
    </div>
</template>

<script>
import themesMixin from '../../mixins/themes.js';
import { converToUnit } from '../../utils/helpers.js';
import { isValueConvertedToNumber } from '../../utils/validators.js';

/**
 * Базовый компонент аватара.
 * Выводит либо изображение, либо текст
 */
export default {
    name: 'SbsBaseAvatar',
    mixins: [themesMixin],
    computed: {
        avatarSize() {
            return converToUnit(this.size);
        },
        avatarStyles() {
            return {
                width: this.avatarSize,
                height: this.avatarSize,
            };
        },
        imageData() {
            return {
                alt: this.text || 'Аватар',
                cover: true,
                preloaderClass: 'rounded-circle',
                src: this.imageSrc,
                width: this.avatarSize,
                height: this.avatarSize,
            };
        },
    },
    props: {
        /**
         * Путь для изображения
         */
        imageSrc: {
            type: String,
            default: '',
        },
        /**
         * Размер аватарки (если передано число, добавляет 'px')
         */
        size: {
            type: [String, Number],
            default: 42,
            validator: isValueConvertedToNumber,
        },
        /**
         * Отображаемый на аватарке текст
         */
        text: {
            type: String,
            default: '',
        },
    },
};
</script>

<style lang="scss">
.sbs-base-avatar {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    overflow: hidden;
    background-clip: padding-box;
    border-radius: $rounded-circle;

    &__text {
        padding: 0 5px;

        @include typo-secondary-medium;
    }

    &__image {
        width: 100%;
        height: 100%;
    }

    &__image-stub {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
    }
}
</style>
